import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
            ? "https://api.digassistant.xyz"
            : "http://localhost:8080";

const UpgradeSuccessPage = () => {
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const handlePremiumCheck = async () => {
            try {
                // console.log('🔄 Waiting for webhook to process and polling premium status...');

                // Poll for premium status until webhook has processed
                const maxAttempts = 30; // 30 attempts = 90 seconds max
                const delay = 3000; // 3 seconds between attempts

                for (let attempt = 0; attempt < maxAttempts; attempt++) {
                    const premiumCheckResponse = await fetch(`${API_BASE_URL}/auth/premium/check`, {
                        method: 'POST',
                        credentials: 'include',
                    });

                    if (premiumCheckResponse.ok) {
                        const data = await premiumCheckResponse.json();
                        // console.log(`✅ Attempt ${attempt + 1}: Premium status check:`, data);

                        // Check if user is premium (webhook has processed)
                        if (data.isPremium) {
                            // console.log('✅ User is premium, webhook processed, redirecting to /premium');
                            navigate('/premium');
                            return; // Exit the function
                        }
                    }

                    // Wait before next attempt (except on last attempt)
                    if (attempt < maxAttempts - 1) {
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }

                // If we get here, we've exhausted all attempts
                // console.log('⏱️ Timeout waiting for premium status to update');
                setError('Upgrade is processing. Please wait a moment and refresh the page.');
                setTimeout(() => {
                    navigate('/service');
                }, 5000);
            } catch (error) {
                console.error('❌ Error calling /auth/premium/check:', error);
                setError('Network error. Redirecting to service page...');
                setTimeout(() => {
                    navigate('/service');
                }, 3000);
            } finally {
                setIsProcessing(false);
            }
        };

        handlePremiumCheck();
    }, [navigate]);

    return (
        <div className="login-format" style={{ padding: "20px", textAlign: "center" }}>
            <div style={{ width: "fit-content", margin: "0 auto" }}>
                {isProcessing ? (
                    <>
                        <h1>Processing your upgrade...</h1>
                        <p>Please wait while we verify your membership.</p>
                    </>
                ) : error ? (
                    <>
                        <h1>Upgrade Complete</h1>
                        <p style={{ color: 'orange' }}>{error}</p>
                        <p>Redirecting...</p>
                    </>
                ) : (
                    <>
                        <h1>Upgrade Successful!</h1>
                        <p>Redirecting...</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default UpgradeSuccessPage;

